import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    profile: {},
    step: 1,
    input: {},
    query: {},
    // serverUrl: "https://generaliapi.herokuapp.com/", //Generalizwiz
    // serverUrl: "https://uat-linebcrm.generali.co.th/" ,//GeneraliUAT
    // serverUrl: "https://linebcrm.generali.co.th/" ,//Generaliของจริง
    serverUrl: process.env.VUE_APP_SERVER_URL,
    serverToken: process.env.VUE_APP_SERVER_TOKEN,
    serverApiKey: process.env.VUE_APP_SERVER_API_KEY,
    // liffId: "1653855836-YAOJXeVB" //Generalizwiz
    // liffId: "1653855836-QV9oqE81" //GeneraliUAT
    // liffId: "1613490262-RXKklx0x" //Generaliของจริง
    liffId: process.env.VUE_APP_LIFF_ID,
    apiToken: process.env.VUE_APP_API_TOKEN,
    zwizPageToken: process.env.VUE_APP_ZWIZ_PAGE_TOKEN,
  },
  mutations: {},
  actions: {},
  modules: {},
});
